<template>
  <page>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs12 sm12 md12 lg12>
          <v-expansion-panels v-model="panel1" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> {{ labels.download }}</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex xs12 sm6 md6 lg6>
                          <v-autocomplete
                            :items="typeList"
                            v-model="forms.type"
                            :label="labels.type"
                            item-text="label"
                            item-value="value"
                            data-vv-name="forms.type"
                            :data-vv-as="labels.type"
                            :error-messages="errors.collect('forms.type')"
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex lg6 xs6></v-flex>

                        <v-flex xs12 sm6 md6 lg6>
                          <v-autocomplete
                            :items="quarterList"
                            v-model="forms.quarter"
                            :label="labels.quarter"
                            item-text="label"
                            item-value="value"
                            data-vv-name="forms.quarter"
                            :data-vv-as="labels.quarter"
                            :error-messages="errors.collect('forms.quarter')"
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex lg6 xs6></v-flex>

                        <v-flex xs12 sm6 md6 lg6>
                          <cal-picker
                            v-model="forms.tranDateFrom"
                            :label="labels.tranDateFrom"
                            :data-vv-as="labels.tranDateFrom"
                            data-vv-name="forms.tranDateFrom"
                            :error-messages="errors.collect('forms.tranDateFrom')"
                            v-validate="tranDateFromValidation"
                          ></cal-picker>
                        </v-flex>
                        <v-flex xs12 sm6 md6 lg6>
                          <cal-picker
                            v-model="forms.tranDateTo"
                            :label="labels.tranDateTo"
                            :data-vv-as="labels.tranDateTo"
                            data-vv-name="forms.tranDateTo"
                            :error-messages="errors.collect('forms.tranDateTo')"
                            v-validate="tranDateToValidation"
                          ></cal-picker>
                        </v-flex>

                        <v-flex xs12 sm6 md6 lg6>
                          <v-text-field
                            v-model="forms.batchNo"
                            :label="labels.batchNo"
                            :error-messages="errors.collect('batchNo')"
                            data-vv-name="batchNo"
                            :data-vv-as="labels.batchNo"
                            v-int-mask="{ intScale: 2 }"
                            type="tel"
                            v-validate="'mask_max_value:99|mask_min_value:1'"
                          ></v-text-field>
                        </v-flex>
                        <v-flex lg6 xs6></v-flex>

                        <v-flex xs12 sm6 md6 lg6>
                          <v-checkbox v-model="forms.excRI" :label="labels.excRI"></v-checkbox>
                        </v-flex>
                        <v-flex xs12 sm6 md6 lg6> </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>

        <v-flex xs12 sm12 md12 lg12>
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> {{ labels.selectionCriteria }}</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <!-- <v-flex xs12 sm6 md6 lg6>
                          <v-text-field readonly v-model="forms.busCls" :label="labels.busCls" :error-messages="errors.collect('forms.busCls')"
                          data-vv-name="forms.busCls" :data-vv-as="labels.busCls" v-validate="'required'" append-icon="mdi-magnify"
                          @click:append="getBusClsHelpList()"></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 md6 lg6>
                        </v-flex> -->
                        <v-flex xs12 sm6 md6 lg6>
                          <v-autocomplete
                            :items="allSelectedList"
                            v-model="forms.busCls"
                            :label="labels.busCls"
                            item-text="label"
                            item-value="value"
                            data-vv-name="busCls"
                            :data-vv-as="labels.busCls"
                            :error-messages="errors.collect('busCls')"
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex xs12 sm6 md6 lg6 v-if="forms.busCls === 'Selected'">
                          <v-autocomplete
                            :items="busClsList"
                            v-model="forms.busClsSelected"
                            :label="labels.busClsSelected"
                            item-text="label"
                            item-value="value"
                            multiple
                            data-vv-name="busClsSelected"
                            :data-vv-as="labels.busClsSelected"
                            :error-messages="errors.collect('busClsSelected')"
                            v-validate="'required'"
                            :loading="loading"
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex xs12 sm6 md6 lg6 v-else></v-flex>

                        <!-- Branch -->
                        <!-- <v-flex xs12 sm6 md6 lg6>
                          <v-text-field readonly v-model="forms.branch" :label="labels.branch" :error-messages="errors.collect('branch')"
                          data-vv-name="forms.branch" :data-vv-as="labels.branch" v-validate="'required'" append-icon="mdi-magnify"
                          @click:append="getBranchHelpList('branch')"></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 md6 lg6>
                        </v-flex> -->
                        <v-flex xs12 sm6 md6 lg6>
                          <v-autocomplete
                            :items="allSelectedList"
                            v-model="forms.branch"
                            :label="labels.branch"
                            item-text="label"
                            item-value="value"
                            data-vv-name="branch"
                            :data-vv-as="labels.branch"
                            :error-messages="errors.collect('branch')"
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex xs12 sm6 md6 lg6 v-if="forms.branch === 'Selected'">
                          <v-autocomplete
                            :items="branchList"
                            v-model="forms.branchSelected"
                            :label="labels.branchSelected"
                            item-text="label"
                            item-value="value"
                            multiple
                            data-vv-name="branchSelected"
                            :data-vv-as="labels.branchSelected"
                            :error-messages="errors.collect('branchSelected')"
                            v-validate="'required'"
                            :loading="loading"
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex lg6 xs6 v-else></v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>
        <v-checkbox v-model="forms.printParam" :label="labels.printParam"></v-checkbox>
        <v-flex xs12 sm12 md12 lg12>
          <v-btn class="mr-3" color="primary"  dark :loading="processing" @click.prevent="doSubmit">
            <v-icon left dark>mdi-file-export</v-icon>
            {{ labels.export }}
          </v-btn>
          <v-btn-toggle dense mandatory v-model="forms.format">
            <v-btn text>
              <span>{{ labels.format }}</span>
              <v-icon>mdi-clipboard-text</v-icon>
            </v-btn>
          </v-btn-toggle>
        </v-flex>
      </v-layout>
    </v-container>

    <!-- <v-dialog v-model="busClsList" width="900px" persistent>
      <bus-cls-help-list v-if="busClsHelpList" :bc="forms.busCls" @close="doClose" @doAssign="doAssign($event)"></bus-cls-help-list>
    </v-dialog>
    <v-dialog v-model="branchList" width="900px" persistent>
      <branch-help-list v-if="branchHelpList" :brn="forms.branch" @close="doClose" @doAssign="doAssign($event)"></branch-help-list>
    </v-dialog> -->

    <v-dialog v-model="processing" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text class="pa-3">
          Processing...
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showErrorDialog" width="800px">
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon>mdi-information</v-icon>
          <v-toolbar-title>System Information</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <div v-if="messages.length > 0" class="pb-3">
            <v-subheader>Oops something went wrong:</v-subheader>
            <ul class="showErrorMsgs">
              <li v-for="(error, index) in messages" :key="index">
                {{ error.message }}
              </li>
            </ul>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click.native="showErrorDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { removeTime } from '@/utils/date'
import isAfter from 'date-fns/isAfter'
import clone from 'clone'
// import BusClsHelpList from '../policy/helplist/BusClsHelpList.vue'
// import BranchHelpList from '../policy/helplist/BranchHelpList.vue'
// import { downloadPrompt } from '@/utils/file'

export default {
  data() {
    return {
      labels: {
        download: 'Selection Criteria',
        type: 'Type of Workman Transactions',
        quarter: 'For Quarter',
        tranDateFrom: 'Quarter Period From*',
        tranDateTo: 'Quarter Period To*',
        batchNo: 'Quarter Batch No.',
        excRI: 'Exclude RI Inwards',
        selectionCriteria: 'Filters',
        busCls: 'Business Class',
        branch: 'Branch',
        export: 'Export To',
        format: 'TEXT',
        printParam: 'Print report runtime parameters',
        busClsSelected: 'Selected Business Class',
        branchSelected: 'Selected Branch'
      },
      forms: {
        type: 'CP',
        quarter: 1,
        tranDateFrom: null,
        tranDateTo: null,
        batchNo: 0,
        excRI: false,
        busCls: 'All',
        branch: 'All',
        printParam: true,
        format: 'TXT'
      },
      typeList: [
        {
          label: 'Claims and Policies',
          value: 'CP'
        },
        {
          label: 'Claims',
          value: 'C'
        },
        {
          label: 'Policies',
          value: 'P'
        }
      ],
      quarterList: [
        {
          label: '1',
          value: 1
        },
        {
          label: '2',
          value: 2
        },
        {
          label: '3',
          value: 3
        },
        {
          label: '4',
          value: 4
        }
      ],
      loading: false,
      processing: false,
      claimsProcessing: false,
      policiesProcessing: false,
      showErrorDialog: false,
      busClsList: false,
      busClsHelpList: false,
      branchList: false,
      branchHelpList: false,
      busClsSelected: null,
      branchSelected: null,
      allSelectedList: [
        {
          label: 'All',
          value: 'All'
        },
        {
          label: 'Selected',
          value: 'Selected'
        }
      ],
      panel1: [0]
    }
  },
  computed: {
    tranDateFromValidation() {
      if (this.forms.tranDateFrom !== '' && this.forms.tranDateFrom !== null && this.forms.tranDateFrom !== undefined) {
        return 'entry|valTranDateFrom:' + this.forms.tranDateTo
      } else {
        return 'required'
      }
    },
    tranDateToValidation() {
      if (this.forms.tranDateTo !== '' && this.forms.tranDateTo !== null && this.forms.tranDateTo !== undefined) {
        return 'entry|valTranDateTo:' + this.forms.tranDateFrom
      } else {
        return 'required'
      }
    },
    displayErrorDialog() {
      return this.messages
    }
  },
  watch: {
    displayErrorDialog: {
      handler: function (messages) {
        if (messages && messages.length > 0) {
          this.showErrorDialog = true
        }
      },
      deep: true
    },
    claimsProcessing: function (value) {
      if (this.forms.type === 'C' || (this.forms.type === 'CP' && this.policiesProcessing === value)) {
        this.processing = value
      }
    },
    policiesProcessing: function (value) {
      if (this.forms.type === 'P' || (this.forms.type === 'CP' && this.claimsProcessing === value)) {
        this.processing = value
      }
    }
  },
  methods: {
    doInit() {
      this.forms.tranDateTo = new Date()
      this.forms.busCls = 'All'

      this.getParameters()
    },
    async getParameters() {
      const apiUrl = this.$store.state.underwriting.dataTransferSettings.menu.initWICTransactionsGIA
      if (apiUrl) {
        try {
          this.loading = true
          const result = await this.$http.get(apiUrl)
          if (result.data.busClsList) {
            this.$set(this, 'busClsList', result.data.busClsList)
          }
          if (result.data.branchList) {
            this.$set(this, 'branchList', result.data.branchList)
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url. [initWICTransactionsGIA]')
      }
    },
    getBusClsHelpList() {
      this.busClsList = true
      this.busClsHelpList = true
    },
    doClose() {
      this.busClsList = false
      this.busClsHelpList = false
      this.branchList = false
      this.branchHelpList = false
    },
    async doAssign(Obj) {
      let from = Obj.from
      switch (from) {
        case 'branch':
          if (Obj.selectedItems.length === Obj.totalLength) {
            this.forms.branch = 'All'
          } else {
            this.forms.branch = []
            this.forms.branch = Obj.selectedItems.toString()
          }
          break
        case 'busCls':
          if (Obj.selectedItems.length === Obj.totalLength) {
            this.forms.busCls = 'All'
          } else {
            this.forms.busCls = []
            this.forms.busCls = Obj.selectedItems.toString()
          }
          break
      }
    },
    getBranchHelpList() {
      this.branchList = true
      this.branchHelpList = true
    },
    doSubmit() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.forms.type === 'C' || this.forms.type === 'CP') {
            this.doExportClaims()
          }
          if (this.forms.type === 'P' || this.forms.type === 'CP') {
            this.doExportPolicies()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doExportClaims() {
      const apiUrl = this.$store.state.underwriting.dataTransferSettings.menu.exportWICClaimsGIA
      if (apiUrl) {
        try {
          this.claimsProcessing = true
          // const result = await this.$http.post(apiUrl, this.forms, {
          //   responseType: 'blob'
          // })
          // if (result.data) {
          //   var headers = result.headers
          //   var blob = new Blob([result.data], { type: headers['content-type'] })
          //   var filename = (headers['content-disposition'] || 'file').split('filename=')[1]
          //   downloadPrompt(blob, filename)
          // }
          let messageFilters = clone(this.forms)
          messageFilters.format = 'PDF'
          await this.$http.post(apiUrl, messageFilters)
          this.claimsProcessing = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.claimsProcessing = false
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url. [exportWICClaimsGIA]')
      }
    },
    async doExportPolicies() {
      const apiUrl = this.$store.state.underwriting.dataTransferSettings.menu.exportWICPoliciesGIA
      if (apiUrl) {
        try {
          this.policiesProcessing = true
          // const result = await this.$http.post(apiUrl, this.forms, {
          //   responseType: 'blob'
          // })
          // if (result.data) {
          //   var headers = result.headers
          //   var blob = new Blob([result.data], { type: headers['content-type'] })
          //   var filename = (headers['content-disposition'] || 'file').split('filename=')[1]
          //   downloadPrompt(blob, filename)
          // }
          let messageFilters = clone(this.forms)
          messageFilters.format = 'PDF'
          await this.$http.post(apiUrl, messageFilters)
          this.policiesProcessing = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.policiesProcessing = false
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url. [exportWICPoliciesGIA]')
      }
    }
  },
  created() {
    this.$validator.extend('valTranDateFrom', {
      getMessage(field, args) {
        return 'Must be same date or earlier date than To Date'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var tranFromDate = args[0]
        if (tranFromDate) {
          return !isAfter(removeTime(value), removeTime(tranFromDate))
        }
      }
    })

    this.$validator.extend('valTranDateTo', {
      getMessage(field, args) {
        return 'To Date must be greater or equal to From Date'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var tranToDate = args[0]
        if (tranToDate) {
          return !isAfter(removeTime(tranToDate), removeTime(value))
        }
      }
    })
  },
  beforeMount() {
    if (this.$store.state.underwriting.dataTransferSettings.init !== 1) {
      this.$store.dispatch('dataTransferInit').then(() => {
        this.doInit()
      })
    } else {
      this.doInit()
    }
  },
  mixins: [MessageMixin]
  // components: {
  //   BusClsHelpList,
  //   BranchHelpList
  // }
}
</script>

<style>
</style>
